import { atomWithKey as atom } from "./atomWithKey";
import { ICmsJourneyPlanner, ICmsNetworkMapStations } from "../Types/Index";

export const journeyPlannerStationAtom = atom<ICmsNetworkMapStations[]>({
  key: "journeyPlannerStationAtom",
  default: [],
});

export const journeyPlannerContentAtom = atom<ICmsJourneyPlanner | null>({
  key: "journeyPlannerContentAtom",
  default: null,
});
